import { useState } from 'react';
import {
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ColumnMapping } from '../helpers';

export const CsvTable = ({
  data,
  error,
  columnMappingOptions,
  setColumnMapping,
}: {
  data: string[][];
  error: string;
  columnMappingOptions: { label: string; value: string }[];
  setColumnMapping: (values: ColumnMapping[]) => void;
}) => {
  const [selectedColumns, setSelectedColumns] = useState<string[]>(Array.from(data[0], () => ''));

  const handleSelectColumn = (index: number, value: string) => {
    const newSelected = selectedColumns.map((oldValue) => (oldValue === value ? '' : oldValue));
    newSelected[index] = value;
    setSelectedColumns(newSelected);
    setColumnMapping(newSelected.map((column, index) => ({ column, index })));
  };

  return (
    <Stack sx={{ mb: 2 }}>
      <TableContainer
        className={data.length > 4 ? 'custom-text-blur' : ''}
        sx={{ maxHeight: 448, position: 'relative', overflowY: 'hidden' }}
      >
        <Table aria-label='mui-table'>
          <TableHead>
            <TableRow>
              {data.length > 0 &&
                Object.values(data[0]).map((value, index) => (
                  <TableCell key={index} sx={{ p: 0 }}>
                    <Select
                      fullWidth
                      key={index}
                      value={selectedColumns[index]}
                      onChange={(event) => handleSelectColumn(index, event.target.value as string)}
                    >
                      {columnMappingOptions.map(({ label, value }) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {Object.values(row).map((value, cellIndex) => (
                  <TableCell key={cellIndex}>{value}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {error && (
        <Typography variant='body2' color='error' pl={1} mt={1}>
          {error}
        </Typography>
      )}
    </Stack>
  );
};
